import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import NextBtn from './next';
import { jumpTo } from '@/utils';

const Page4 = ({ data, onNext }, ref) => {

  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleDetail = () => {
    jumpTo(`storm://app/userzone?userID=${data.mostReadColumnUser.userId}&userName=${data.mostReadColumnUser.nickname}`)
  }

  return (
    <Container className="page page2" ref={containerRef}>
      {!!data.readColumnCount && (
        <div className="data-wrap">
          <div className="user-data">2025这一年</div>
          <div className="user-data">
            你阅读了<span className="light-data">{data.readColumnCount}</span>
            篇市值风云研报
          </div>
          <div className="user-data">
            超越了<span className="light-data">{data.readColumnX}%</span>
            的风云用户
          </div>
          <div className="user-data">你阅读研报最多的作者是</div>
          {data.mostReadColumnUser && (
            <div className="user-data" onClick={handleDetail}>
              <img src={data.mostReadColumnUser.avatar} alt="" className="article-user"/>
              <span className="article-name">@{data.mostReadColumnUser.nickname}</span>
            </div>
          )}
          <div className="user-data">如果有机会，你想问TA什么呢?</div>
          <img className="award-tip" src="https://file.wogoo.com/image/activity/active_205/award-tip@2x.png" alt="" />
        </div>
      )}

      {!data.readColumnCount && (
        <div className="data-wrap">
          <div className="user-data">2025年8月22日</div>
          <div className="user-data">大盘涨至<span className="light-data">3825</span>点，创十年新高</div>
          <div className="user-data">2015年入市的朋友此时泪流满面！</div>
        </div>
      )}

      <div className="data-bg">
        <img
          className="logo-img"
          src="https://file.wogoo.com/image/activity/active_205/page4-bg@2x.png"
          alt=""
        />
      </div>
      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/bottom-arrow@2x.png" alt=""/>
      </div>
      <div className="page-logo">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page-logo@2x.png" alt=""/>
      </div>
      <NextBtn onClick={onNext} />
    </Container>
  );
};

const Container = styled.div`
.article-user {
  width: 35px;
  height: 35px;
  margin-right: 6px;
  border-radius: 17.5px;
  vertical-align: middle;
}
.article-name {
  color: #D57713;
  font-size: 24px;
  color: #D57713;
  line-height: 39px;
}
`;

export default React.memo(forwardRef(Page4));



// WEBPACK FOOTER //
// ./src/views/activity_205/page4.js